import { render, staticRenderFns } from "./AreaSet.vue?vue&type=template&id=0c711352&scoped=true&"
import script from "./AreaSet.vue?vue&type=script&lang=ts&"
export * from "./AreaSet.vue?vue&type=script&lang=ts&"
import style0 from "./AreaSet.vue?vue&type=style&index=0&id=0c711352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c711352",
  null
  
)

export default component.exports